"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;
var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));
var _Zoom = _interopRequireDefault(require("@material-ui/core/Zoom"));
var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _clsx5 = _interopRequireDefault(require("clsx"));
var _simplebarReact = _interopRequireDefault(require("simplebar-react"));
require("simplebar-react/dist/simplebar.min.css");
var _detectBrowser = require("detect-browser");
var _pittaModules = require("@thingsw/pitta-modules");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paperRoot: {
      borderRadius: 12,
      boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.05), 0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08)",
      border: "1px solid ".concat(_pittaModules.LightColors.primary["5"])
    },
    darkPaperRoot: {
      color: _pittaModules.DarkColors.primary["1"],
      backgroundColor: _pittaModules.SemanticDarkColors.primary["1"],
      minWidth: 166
    },
    paperTimeRoot: {
      maxHeight: 305,
      overflowY: "auto"
    },
    selectRoot: {
      //  ux-ui프로젝트 디자인으로 아래css추가 , selectmenu일 때 전체적용(Leehj)
      borderRadius: 8,
      padding: "8px 16px"
    },
    //  ux-ui프로젝트 setting 메뉴아이템 스크롤 모양 변경
    selectSettingRoot: {
      overflowY: "hidden",
      width: 267
    },
    selectMenu: {
      overflowX: "hidden",
      flex: 1,
      height: 320
    },
    menuListRoot: function menuListRoot(props) {
      return props.dense ? {
        padding: "8px 0"
      } : {
        padding: "16px 0"
      };
    }
  };
});
var Menu = function Menu(props) {
  var innerClasses = useStyles({
    dense: props.dense
  });
  var open = props.open,
    anchorEl = props.anchorEl,
    children = props.children,
    onClickAway = props.onClickAway,
    classes = props.classes,
    placement = props.placement,
    transformOrigin = props.transformOrigin,
    modifiers = props.modifiers,
    onKeyDown = props.onKeyDown,
    style = props.style,
    paperClasses = props.paperClasses,
    menuScroll = props.menuScroll,
    container = props.container,
    mouseEvent = props.mouseEvent,
    darkMode = props.darkMode,
    select = props.select,
    settingScroll = props.settingScroll;
  var browser = (0, _detectBrowser.detect)();
  return /*#__PURE__*/_react.default.createElement(_Popper.default, {
    open: open,
    anchorEl: anchorEl,
    role: undefined,
    placement: placement,
    modifiers: modifiers,
    style: _objectSpread({
      zIndex: 99
    }, style)
    // popperOptions={{ positionFixed: "fixed" }}
    ,
    transition: true,
    disablePortal: true,
    container: container
  }, function (_ref) {
    var _clsx, _clsx3;
    var TransitionProps = _ref.TransitionProps,
      placement = _ref.placement;
    return (
      // mantis - 10667,  mac/safari 15.4버전은 grow대신 zoom으로 사용. 15.4에서 버그가 있어서 15.4에서는 zoom으로 대체 (Leehj)
      (browser === null || browser === void 0 ? void 0 : browser.name) === "safari" && browser.version === "15.4.0" && browser.os === "Mac OS" ? /*#__PURE__*/_react.default.createElement(_Zoom.default, _extends({}, TransitionProps, {
        style: {
          transformOrigin: transformOrigin || "center top"
        }
      }), /*#__PURE__*/_react.default.createElement(_Paper.default, {
        elevation: 0,
        classes: _objectSpread({
          root: (0, _clsx5.default)(innerClasses.paperRoot, menuScroll && innerClasses.paperTimeRoot, (_clsx = {}, _defineProperty(_clsx, innerClasses.darkPaperRoot, darkMode), _defineProperty(_clsx, innerClasses.selectRoot, select), _defineProperty(_clsx, innerClasses.selectSettingRoot, settingScroll), _clsx))
        }, paperClasses)
      }, /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
        onClickAway: onClickAway,
        mouseEvent: mouseEvent
      }, /*#__PURE__*/_react.default.createElement(_MenuList.default, {
        autoFocusItem: open,
        id: "menu-list-grow",
        classes: _objectSpread({
          root: (0, _clsx5.default)(innerClasses.menuListRoot, _defineProperty({}, innerClasses.selectMenu, select && settingScroll))
        }, classes),
        onKeyDown: onKeyDown
      }, settingScroll && select ? /*#__PURE__*/_react.default.createElement(_simplebarReact.default, {
        style: {
          height: "100%",
          overflowX: "hidden"
        }
      }, children) : children)))) : /*#__PURE__*/_react.default.createElement(_core.Grow, _extends({}, TransitionProps, {
        style: {
          transformOrigin: transformOrigin || "center top"
        }
      }), /*#__PURE__*/_react.default.createElement(_Paper.default, {
        elevation: 0,
        classes: _objectSpread({
          root: (0, _clsx5.default)(innerClasses.paperRoot, menuScroll && innerClasses.paperTimeRoot, (_clsx3 = {}, _defineProperty(_clsx3, innerClasses.darkPaperRoot, darkMode), _defineProperty(_clsx3, innerClasses.selectRoot, select), _defineProperty(_clsx3, innerClasses.selectSettingRoot, settingScroll), _clsx3))
        }, paperClasses)
      }, /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
        onClickAway: onClickAway,
        mouseEvent: mouseEvent
      }, /*#__PURE__*/_react.default.createElement(_MenuList.default, {
        autoFocusItem: open,
        id: "menu-list-grow",
        classes: _objectSpread({
          root: (0, _clsx5.default)(innerClasses.menuListRoot, _defineProperty({}, innerClasses.selectMenu, select && settingScroll))
        }, classes),
        onKeyDown: onKeyDown
      }, settingScroll && select ? /*#__PURE__*/_react.default.createElement(_simplebarReact.default, {
        style: {
          height: "100%",
          overflowX: "hidden"
        }
      }, children) : children))))
    );
  });
};
exports.Menu = Menu;